import React, { useEffect, useRef } from 'react';
import { useSidebar } from '../../context/Sidebar';
import { t } from 'i18next';
import WindowWidget from '../WindowWidget/WindowWidget';

/**
 * In order to change the color and zIndex of the "Merlin" logo, MUST mount and
 * unmount this component.
 */
export const Sidebar: React.FC<{
  className?: string;
  z?: number;
}> = ({ className = '', children, z = 60 }) => {
  const { isOpen, content, setContent, setTitle, title } = useSidebar();
  const boxRef = useRef<HTMLDivElement | null>(null);

  const onChange = () => {};

  return isOpen ? <aside>{content || children}</aside> : <></>;
};
